export const getRooms = (state) => state.rooms